import { useEffect, useRef, useState } from 'react'
import { animated, useTransition } from 'react-spring'

import ArrowCircle from '../Icons/ArrowCircle'
import { InnerContainer } from './InnerContainer'

export const DesktopContainer = ({ id, className, color, secondary, title, items, setLock, children }) => {
  const [openDesktop, setOpenDesktop] = useState(false)
  const [selectedModal, setSelectedModal] = useState(items?.[0]?.key || '')
  const [modal, setModal] = useState(items?.[0]?.content)
  const dektopContainer = useRef(null)

  const transition = useTransition(openDesktop, null, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 }
  })

  const handleOnClick = (key, content) => {
    setSelectedModal(key)
    setModal(content)
  }

  const handleOpen = (enable) => {
    setOpenDesktop(enable)
    setLock?.(enable)
  }

  useEffect(() => {
    if (openDesktop) {
      dektopContainer.current.parentElement.scrollLeft = dektopContainer.current.offsetLeft
    }
  }, [openDesktop])

  return (
    <div ref={dektopContainer} className={`main-page-desktop ${color} ${openDesktop ? 'open' : 'closed'} ${className}`}>
      <div className="arrow-circle-container" onClick={() => handleOpen(false)}>
        <ArrowCircle color={color} />
      </div>

      <div className="inner-block">
        <div className="left side">
          <h1 className="urbana uppercase">{title}</h1>

          {transition.map(
            ({ item, props }, i) =>
              item && (
                <animated.div key={`section-${id}-index-${i}`} className="left-side-desktop" style={props}>
                  <div className="index-container-desktop">
                    <InnerContainer items={items} color={secondary} selectedItem={selectedModal} onClick={(item) => handleOnClick(item.key, item.content)} />
                    <div className={`back-square ${color}`} />
                  </div>
                </animated.div>
              )
          )}

          <div className="front-logo-container-desktop" id={`${id}-logo-desktop`}>
            {children}
          </div>
        </div>
        <div className="right-container">
          <div className="top spacer" />
          <div className="right side" onClick={() => handleOpen(true)}>
            <div className="content">{modal}</div>
          </div>
          <div className="bottom spacer" />
        </div>
      </div>
    </div>
  )
}
